const React = require('react');


/* eslint-disable */
module.exports = (props) => {
  return (
    <svg
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      className={`dB strokeCT>path ` + (props.className || '')}
    >
      <path
        d="M1 1L7 7.00001M7 7.00001L13 13M7 7.00001L13 1M7 7.00001L1.00001 13"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
